import React, { createContext, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useVisualViewport } from '@wix/da-ds/pkg/hooks/useVisualViewport';
import { MeasuredCookieType } from '../redux/types';
import { useMeasuredCookieState, DEFAULT_SIZE, } from '../useMeasuredCookieState';
export var ScreenSizeContext = createContext(DEFAULT_SIZE.desktop);
ScreenSizeContext.displayName = 'ScreenSizeContext';
export var ScreenSizeContextProvider = function (_a) {
    var children = _a.children;
    var isMobile = useContext(MobileContext);
    var _b = useMeasuredCookieState(MeasuredCookieType.SCREEN_WIDTH, 'both', DEFAULT_SIZE), _c = _b.containerSize, containerSize = _c === void 0 ? isMobile ? DEFAULT_SIZE.mobile : DEFAULT_SIZE.desktop : _c, updateContainerSize = _b.updateContainerSize;
    // VisualViewport
    useVisualViewport(updateContainerSize);
    return (React.createElement(ScreenSizeContext.Provider, { value: containerSize }, children));
};
ScreenSizeContextProvider.displayName = 'ScreenSizeContextProvider';
//# sourceMappingURL=ScreenSizeContext.js.map